// extracted by mini-css-extract-plugin
export default {"container":"info-description_container__hP5dd","title":"info-description_title__oB+xC","description":"info-description_description__Dh3JC"};